import { api, unwrap } from './client';

// ── Departure locations ────────────────────────────────────────────
export function listLocations() {
  return unwrap(api.get('/api/transport/locations'));
}

export function createLocation(payload) {
  return unwrap(api.post('/api/transport/locations', payload));
}

export function updateLocation(id, payload) {
  return unwrap(api.put(`/api/transport/locations/${id}`, payload));
}

export function deleteLocation(id) {
  return unwrap(api.delete(`/api/transport/locations/${id}`));
}

// ── Buses ──────────────────────────────────────────────────────────
export function listBuses() {
  return unwrap(api.get('/api/transport/buses'));
}

export function createBus(payload) {
  return unwrap(api.post('/api/transport/buses', payload));
}

export function updateBus(id, payload) {
  return unwrap(api.put(`/api/transport/buses/${id}`, payload));
}

export function deleteBus(id) {
  return unwrap(api.delete(`/api/transport/buses/${id}`));
}

// ── Bus ↔ pilgrimage assignments ───────────────────────────────────
export function listAssignments(eventId) {
  return unwrap(api.get('/api/transport/assignments', { params: eventId ? { eventId } : {} }));
}

export function createAssignment(payload) {
  return unwrap(api.post('/api/transport/assignments', payload));
}

export function deleteAssignment(id) {
  return unwrap(api.delete(`/api/transport/assignments/${id}`));
}
